export const Images = {
  web3: {
    metamask: require("./web3/metamask.png"),
    wallet: require("./web3/wallet.png"),
  },
  login: {
    bg: require("./images/bg-img.png"),
  },
};

export { default as logo1 } from "./images/logo1.png";

export { default as twittericon } from "./images/twitter.png";
export { default as telegramicon } from "./images/telegram.png";

export { default as cardimg } from "./images/cardimg.png";

export { default as collectioncardimg } from "./images/collectioncardimg.png";
export { default as collectionimg1 } from "./images/collectionimg1.png";

export { default as twittericons } from "./images/twittericon.png";
export { default as mailicons } from "./images/mailicon.png";
export { default as mailicons2 } from "./images/mailicon2.png";

export { default as youtubeicons } from "./images/youtubeicon.png";
export { default as telegramicons1 } from "./images/telegramicon1.png";
export { default as telegramicons2 } from "./images/telegramicon2.png";
export { default as soonimg } from "./images/soonimg.png";
export { default as mobilesoonimg } from "./images/mobilesoonimg.png";

export { default as textBox } from "./images/textBox.svg";
export { default as textBox2 } from "./images/textBox2.svg";
export { default as clipicon } from "./images/clipicon.png";
export { default as ethicon } from "./images/ethicon.png";
export { default as modalimg } from "./images/modalimg.png";
export { default as heroimg } from "./images/heroimg.png";

export { default as twsvg } from "./images/tsvg.svg";
export { default as tsvg1 } from "./images/tsvg1.svg";
export { default as tsvg2 } from "./images/tsvg2.svg";
export { default as ysvg } from "./images/ysvg.svg";
export { default as msvg } from "./images/msvg.svg";

export { default as video3 } from "./images/videogif.gif";

// c98 design images

export { default as connectbtnimg } from "./images/c98/connectbtnimg.png";
export { default as c98img } from "./images/c98/c98img.png";
export { default as collectionimg } from "./images/c98/collectionimg.png";
export { default as c98cardimg } from "./images/c98/cardimg.png";
export { default as c98cardimg2 } from "./images/c98/cardimg2.png";
export { default as arrowimg } from "./images/c98/arrow.png";
export { default as spaceimg } from "./images/c98/spaceimg.png";
export { default as mintbtnimg } from "./images/c98/mintbtnimg.png";
export { default as stakingimg } from "./images/c98/stakingimg.png";
export { default as mobilestakingimg } from "./images/c98/mobilestakingimg.png";
export { default as innerimg } from "./images/c98/innerimg.png";
export { default as divider } from "./images/c98/divider.png";
export { default as maincardimg } from "./images/c98/maincardimg.png";
export { default as checkicon } from "./images/c98/checkicon.png";
export { default as arrowicon } from "./images/c98/arrowicon.png";
export { default as nftimg } from "./images/c98/nftimg.png";
export { default as nftimg1 } from "./images/c98/nftimg1.png";
export { default as stakingbtn } from "./images/c98/stakingbtn.png";
export { default as fuisionimg } from "./images/c98/fusionimg.png";
export { default as notconnectimg } from "./images/c98/notconnectimg.png";

export { default as eligableimg } from "./images/c98/eligableimg.png";
export { default as summaryimg } from "./images/c98/summaryimg.png";
export { default as msummaryimg } from "./images/c98/msummaryimg.png";
export { default as earnedimg } from "./images/c98/earnedimg.png";
export { default as nodataimg } from "./images/c98/nodatamesg.png";
export { default as cancelbtn } from "./images/c98/cancelbtn.png";
export { default as modalpic } from "./images/c98/modalpic.png";
export { default as c98img1 } from "./images/c98/c98img1.png";
export { default as walletconnect } from "./images/c98/walletconnect.png";
export { default as herobg } from "./images/c98/herobg.png";
export { default as heroimg3 } from "./images/c98/heroimg3.png";
export { default as heroimg4 } from "./images/c98/heroimg4.png";
export { default as heroimg2 } from "./images/c98/heroimg2.png";
export { default as mobilecardimg } from "./images/c98/mobilecardimg.png";
export { default as mintimg1 } from "./images/c98/mintimg1.png";
export { default as mintimg2 } from "./images/c98/mintimg2.png";
export { default as mintimg3 } from "./images/c98/mintimg3.png";
export { default as mintimg } from "./images/c98/mintimg.png";
export { default as c98nodataimg } from "./images/c98/nodataimg.png";
export { default as divider2 } from "./images/c98/divider2.png";
export { default as divider3 } from "./images/c98/divider3.png";
export { default as crossicon } from "./images/c98/crossicon.png";
export { default as frame } from "./images/c98/frame.png";
export { default as maskimg } from "./images/c98/maskimg.png";
export { default as unstakebtn } from "./images/c98/unstakebtn.png";
export { default as cardvideo } from "./videos/cardvideo.mp4";
